// extracted by mini-css-extract-plugin
module.exports = {"heading-container":"i_Em","heading":"i_En","back-icon":"i_Eo","no-parent":"i_Ep"};